<p-tabMenu [model]="patientsMenu">
</p-tabMenu>

<!-- THIS IS REQUIRED FOR TABS TO WORK -->
<div style="padding: 0.5em; padding-left: 4px;">
  <router-outlet></router-outlet>
</div>
